export enum PageEnum {
  PERMISSION = '/permission',
  // 用户中心的默认配置
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list'
}
export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight'
